import { some } from 'lodash';

/*
 * A very simple shallow comparison of two objects. Checks for key sizes
 * before doing a strict comparison of each keys.
 */
export default (objectA, objectB) => {
  const aPresent = !!objectA;
  const bPresent = !!objectB;
  if (aPresent !== bPresent) { return false; }
  if (!aPresent) { return true; }

  if (Object.keys(objectA).length !== Object.keys(objectB).length) {
    return false;
  }

  return !some(objectA, (property, key) => objectB[key] !== property);
};
